export default __webpack_public_path__ + "static/media/mprojectfeature5.338d126f.png";